import { Injectable } from '@angular/core';
import { BudgetRevenueAdminFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-revenue-admin/budget-revenue-admin-find-many-query.dto';
import { BudgetRevenueAdminFindInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-revenue-admin/budget-revenue-admin-find.dto';
import { BudgetRevenueAdminPageInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-revenue-admin/budget-revenue-admin-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisBudgetRevenueAdminService extends BaseService {
  protected baseUrl = '/basis/catalog/budget-revenue-admin';

  public findWithPagination(
    queryParams: BudgetRevenueAdminFindManyQueryInterface
  ): Observable<BudgetRevenueAdminPageInterface> {
    return this.http.get<BudgetRevenueAdminPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<BudgetRevenueAdminFindInterface> {
    return this.http.post<BudgetRevenueAdminFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
